module.exports = __webpack_public_path__ + "assets/paid-out.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/paid-out.png
// module id = 1204
// module chunks = 7